import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true
  }} className="py-16 px-4" data-id="element-49">
      <div className="max-w-3xl mx-auto" data-id="element-50">
        <div className="bg-gradient-to-br from-primary/20 to-accent/20 border-2 border-primary rounded-2xl p-8 md:p-12 text-center" data-id="element-51">
          <ShieldCheckIcon className="w-20 h-20 text-primary mx-auto mb-6" data-id="element-52" />

          <h3 className="text-3xl md:text-4xl font-black mb-4" data-id="element-53">
            Garantía de devolución de 45 días
          </h3>

          <p className="text-xl text-gray-300 mb-6" data-id="element-54">
            Sin preguntas. Si no estás satisfecho, te devolvemos tu dinero.
          </p>

          <p className="text-sm text-gray-400" data-id="element-55">
            Estamos tan seguros de que este sistema te ayudará que asumimos todo
            el riesgo.
          </p>
        </div>
      </div>
    </motion.section>;
}